'use client'; // Error components must be Client Components

import { Button } from '@/components/Button/Button';
import { useUser } from '@/hooks/useUser';
// eslint-disable-next-line no-restricted-imports
import { redirect } from 'next/navigation';
import { useLocale, useTranslations } from 'next-intl';

const Error = ({ reset }: { reset: () => void }) => {
  const t = useTranslations();
  const locale = useLocale();
  const { getCurrentUser } = useUser();
  const { error } = getCurrentUser();

  if (error) {
    redirect(`/api/auth/logout?locale=${locale}`);
  }

  return (
    <div className="flex size-full flex-col items-center justify-center gap-400">
      <h2 className="label-large">{t('error_general')}</h2>
      <Button onClick={() => reset()}>{t('error_general_action')}</Button>
    </div>
  );
};

// eslint-disable-next-line no-restricted-exports
export default Error;
